<template>
    <div class="popup">
        <div class="popup-box">
            <div
                v-for=" (item, index) in list"
                :key="'order' + index"
                class="popup-box-item"
            >
                <div class="item-time">{{ item.time }}</div>
                <div class="item-gx">恭喜</div>
                <div class="item-store">{{ item.storeName }}</div>
                <img v-if="item.source.sourceAvatar" :src="item.source.sourceAvatar" alt="">
                <div class="item-source" v-if="item.source.sourceName">{{ item.source.sourceName }}</div>
                <div class="item-share">{{ item.share }}</div>
                <div class="item-card">{{ `消费了【 ${ item.cardNum ? item.cardName : '' } ${ item.cardNum ? '*'  : '' } ${ item.cardNum ? item.cardNum : '' } ${ item.goodsNum ? '+' : '' } ${ item.goodsNum ? item.goodsName : '' } ${ item.goodsNum ? '*'  : '' } ${ item.goodsNum ? item.goodsNum : '' }】` }}</div>
                <div class="item-amount">{{ item.amount / 100 }}</div>
                <div class="item-unit">元</div>
            </div>
        </div>
    </div>
</template>

<script>
import {  timestampToDatetime } from '../../../utils/validate';
export default {
    name: 'PopupOrder',
    props: {
        order: {
            type: Array,
            default: () => []
        },
    },
    data() {
        return {
            list: [
                
            ],
        } 
    },
    created() {
        this.getFansList(this.order)
    },
    methods: {
        getFansList(list) {
            let fans = []
            list.forEach(item => {
                fans.push({
                    time: timestampToDatetime(item.payAt * 1000, 1),
                    storeName: item.storeName,
                    source:{
                        sourceName: item.sourceName,
                        sourceAvatar: item.sourceAvatar
                    },
                    share: `分享顾客【${item.userName}】`,
                    cardName: item.cardName,
                    cardNum: item.cardNum,
                    goodsName: item.goodsName,
                    goodsNum: item.goodsNum,
                    amount: item.amount
                })
            })
            this.list = fans
        },
    },
    
}
</script>

<style lang="scss" scoped>
    .popup {
        position: fixed;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        animation: popupAnimation 5s forwards;
        // background: rgba(0, 0, 0, 0.5);
        width: 100%;
        height: 100%;
        z-index: 9999;
        &-box {
            width: 100%;
            padding: 4px;
            position: absolute;
            top: 50%;
            left: 50%;
            border-radius: 10px;
            transform: translate(-50%, -50%);
            box-shadow: inset -5px -5px 20px 0px rgba(255, 255, 255, 0.3),inset 5px 5px 20px 0px rgba(255, 255, 255, 0.3);
            border: 2px solid #01ADF7;
            &-item {
                display: flex;
                align-items: center;
                justify-content: center;
                .item-time {
                    color: #fff;
                    font-size: 5.8px;
                    font-weight: 600;
                }
                .item-gx {
                    color: #E9AD01;
                    font-size: 5.8px;
                    font-weight: 600;
                    padding: 0 2px;
                }
                .item-store {
                    color: #fff;
                    font-size: 5.8px;
                    font-weight: 600;
                    max-width: 210px;
                    white-space: nowrap;
                    text-overflow: ellipsis;
                    -o-text-overflow: ellipsis;
                    overflow: hidden;
                }
                img {
                    width: 12.72px;
                    height: 12.72px;
                    border-radius: 50%;
                    margin-left: 4px;
                }
                .item-source {
                    color: #E9AD01;
                    font-size: 5.8px;
                    font-weight: 600;
                    max-width: 150px;
                    white-space: nowrap;
                    text-overflow: ellipsis;
                    -o-text-overflow: ellipsis;
                    overflow: hidden;
                    margin-left: 4px;
                }
                .item-share {
                    color: #fff;
                    font-size: 5.8px;
                    font-weight: 600;
                    max-width: 160px;
                    white-space: nowrap;
                    text-overflow: ellipsis;
                    -o-text-overflow: ellipsis;
                    overflow: hidden;
                    margin-left: 4px;
                }
                .item-card {
                    color: #fff;
                    font-size: 5.8px;
                    font-weight: 600;
                    max-width: 360px;
                    white-space: nowrap;
                    text-overflow: ellipsis;
                    -o-text-overflow: ellipsis;
                    overflow: hidden;
                }
                .item-amount {
                    color: #E9AD01;
                    font-size: 5.8px;
                    font-weight: 600;
                    margin-left: 10px;
                }
                .item-unit {
                    color: #E9AD01;
                    font-size: 5.8px;
                    font-weight: 600;
                    margin-left: 4px;
                }
            }
        }
    }
    @keyframes popupAnimation {
        0% {
            transform: translate(-50%, -50%) scale(0);
            opacity: 0;
        }
        30% {
            transform: translate(-50%, -50%) scale(1);
            opacity: 1;
        }
        70% {
            transform: translate(-50%, -50%) scale(1);
            opacity: 1;
        }
        100% {
            transform: translate(-50%, -50%) scale(0);
            opacity: 0;
        }
    }
</style>